/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D%0A._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D");

import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { PanelContainer } from '@atlassian/panel-system/panel-container';
import type { PreviewPanelProps } from './types';
const styles = {
  wrapper: "_0jFU0VN91d _0KLXrulfZc"
};

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanel = ({
  children,
  testId
}: PreviewPanelProps): React.JSX.Element => {
  if (fg('ads-panel-system-gpp')) {
    return <PanelContainer testId={testId}>{children}</PanelContainer>;
  }
  return <Stack xcss={styles.wrapper} testId={testId}>
			{children}
		</Stack>;
};